export default __webpack_public_path__ + "static/media/dashboard.4b70fe42.svg";